import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { Action, ElMessage, ElMessageBox } from 'element-plus';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const url = route.query.url as any
const open = () => {
  ElMessageBox.alert('网上办事大厅已经更新迭代，如需办理事项，请到最新网上办理大厅办理，原网上办理大厅不在提供事项办理服务。',
   '温馨提示', 
   {
    confirmButtonText: '好的',
    callback: (action: Action) => {
      location.href = url
    },
  })
}
open()
//alert('网上办事大厅已经更新迭代，如需办理事项，请到最新网上办理大厅办理，原网上办理大厅不在提供事项办理服务。')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("iframe", { src: _unref(url) }, null, 8, _hoisted_1)
  ]))
}
}

})